import Page from '../../components/Page';
import { useSelector } from 'react-redux';
import { getFirstName } from '../../utilities/user';
import { selectUserProfile, selectUserRoles } from '../../selectors/user';
import CircularProgress from 'raydiant-elements/core/CircularProgress';
import Center from 'raydiant-elements/layout/Center';
import PageLayout from '../../components/PageLayout/PageLayout';
import PageTitle from '../../components/PageLayout/PageTitle';
import DisplaiAcademyCard from './DisplaiAcademyCard';
import GetAPlanNowCard from './GetAPlanNowCard';
import QuickStartGuide from './QuickStartGuide';
import { Redirect } from 'react-router-dom';
import * as paths from '../../routes/paths';
import { useCurrentUserRoles } from '../../hooks';
import { useEffect } from 'react';
import analytics from '../../clients/analyticsClient';

const GettingStartedPage = () => {
  const currentUser = useSelector(selectUserProfile);
  const userRoles = useSelector(selectUserRoles);
  const roles = useCurrentUserRoles();

  useEffect(() => {
    analytics.trackPageView({ page: 'Getting Started' });
  }, [currentUser]);

  if (!currentUser || userRoles.length === 0) {
    return (
      <Page>
        <Center>
          <CircularProgress size={30} />
        </Center>
      </Page>
    );
  }

  if (!roles.isProUser) {
    return <Redirect to={paths.screens()} />;
  }

  return (
    <Page title="Getting Started - Displai">
      <PageLayout
        title={
          <PageTitle
            title={`Hi, ${getFirstName(currentUser!)}`}
            subTitle="Ready to get started?"
          />
        }
      >
        <div className="flex flex-col xl:flex-row gap-8 xl:gap-12">
          <div className="flex flex-col gap-8 w-full xl:w-auto">
            <DisplaiAcademyCard />
            <GetAPlanNowCard />
          </div>
          <QuickStartGuide />
        </div>
      </PageLayout>
    </Page>
  );
};

export default GettingStartedPage;
